import React from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { ContentWrapper } from './ContentWrapper';
import { String } from './String';
import { config, Icons } from '../index';

export interface FooterProps {
  /* Content background color */
  backgroundColor?: string;
  /* Content padding */
  padding?: string;
  /* Content margin */
  margin?: string;
  /* Content max width */
  maxWidth?: string;
  /* Content min height */
  minHeight?: string;
  /* Content additional config props */
  className?: string;
  /* Header onClick callBack */
  onClick?: (event?: MouseEvent) => void;
}

interface SectionWrapperProps extends FooterProps {
  width?: string;
  flexDirection?: string;
}

const FooterContentWrapper = styled.div<FooterProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SectionWrapper = styled.div<SectionWrapperProps>`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'column'};
  align-items: flex-start;
  gap: ${config.spacingSmall};
  width: ${(props) => props.width || 'auto'};
`;

export const Footer: React.FC<FooterProps> = ({
  backgroundColor = config.secondary,
  padding = '50px 100px',
  margin,
  maxWidth = '1920',
  minHeight = '360',
  className,
}) => {
  return (
    <ContentWrapper
      backgroundColor={backgroundColor}
      margin={margin}
      padding={padding}
      maxWidth={maxWidth}
      minHeight={minHeight}
      className={className}
    >
      <FooterContentWrapper>
        <SectionWrapper width="15%">
          <String
            string="Rentify"
            fontSize="36px"
            fontWeight="700"
            color={config.white}
          />
          <String
            string="Sed ut perspiciatis unde omnis iste natus error sit voluptatem 
            accusantium dolorem s error sit voluptatem  accusantium dolore"
            fontSize="16px"
            fontWeight="400"
            color={config.white}
          />
        </SectionWrapper>
        <SectionWrapper>
          <String
            string="Quick links"
            fontSize="20px"
            fontWeight="700"
            color={config.white}
            onClick={() => console.log('Quick links')}
          />
          <String
            string="Home"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Home')}
          />
          <String
            string="Browse"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Browse')}
          />
          <String
            string="List an item"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('List an item')}
          />
          <String
            string="Profile"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Profile')}
          />
        </SectionWrapper>
        <SectionWrapper>
          <String
            string="Categories"
            fontSize="20px"
            fontWeight="700"
            color={config.white}
            onClick={() => console.log('Categories')}
          />
          <String
            string="Tools"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Tools')}
          />
          <String
            string="Outdoor Gear"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Outdoor Gear')}
          />
          <String
            string="Party & Wedding Equipment"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Party & Wedding Equipment')}
          />
          <String
            string="Electronics"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Electronics')}
          />
        </SectionWrapper>
        <SectionWrapper>
          <String
            string="Recreational Vehicles"
            fontSize="20px"
            fontWeight="700"
            color={config.white}
            onClick={() => console.log('Recreational Vehicles')}
          />
          <String
            string="Closing"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Closing')}
          />
          <String
            string="Home and Kitchen"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('Home and Kitchen')}
          />
          <String
            string="All Categories"
            fontSize="20px"
            fontWeight="400"
            color={config.white}
            onClick={() => console.log('All Categories')}
          />
        </SectionWrapper>
        <SectionWrapper flexDirection="row">
          <Icons size={32} icon="facebook" />
          <Icons size={32} icon="tweeter" />
          <Icons size={32} icon="instagram" />
        </SectionWrapper>
      </FooterContentWrapper>
    </ContentWrapper>
  );
};
